<template>
    <section id="settings" class="main-container">
        <h3 class="title is-spaced">Les meves dades</h3>
        <h3 class="subtitle">Completa el perfil</h3>

        <!-- <transition name="fade">
            <p v-if="showSuccess" class="has-text-primary">Perfil modificat</p>
        </transition> -->

        <form @submit.prevent v-if="currentUser">
            <label class="label" for="userName">Correu</label>
            <input v-model.trim="currentUser.email" type="text" disabled :placeholder="currentUser.email" id="email" />

            <label class="label" for="name">Nom</label>
            <input v-model.trim="name" type="text" :placeholder="name" maxlength="150" id="name" />                

            <!-- <label class="label" for="name">Població</label>
            <input v-model.trim="city" type="text" :placeholder="city" id="city" />

            <label class="label" for="name">Comarca</label>
            <div class="select zis-primary">
                <select v-model="territorial">
                    <option
                    v-for="t in territorials"
                    :value="t.id"
                    v-bind:key="t.id"
                    >{{ t.description }}</option>
                </select>
            </div>

            <label class="label" for="name">Telèfon</label>
            <input v-model.trim="phone" type="text" :placeholder="phone" maxlength="20" id="name" />                

            <label class="label" for="name">Correu de contacte (es farà visible)</label>
            <input v-model.trim="contactEmail" type="text" :placeholder="contactEmail" maxlength="200" id="contactEmail" />                

            <label class="label" for="name">Web</label>
            <input v-model.trim="web" type="text" :placeholder="web" maxlength="250" id="name" />                 -->

            <label class="label" for="name">Una mica sobre tu</label>
            <textarea class="ztextarea" v-model.trim="description" type="text" maxlength="2500" :placeholder="description" id="name" ></textarea>

            <!-- <label class="label" for="name">Horaris, contacte, obertura</label>
            <textarea class="ztextarea" v-model.trim="contact" type="text" maxlength="2500" :placeholder="contact" id="name" ></textarea> -->

            <button @click="updateProfile" class="button is-danger">Actualitza</button>
        </form>

        <!-- <pre>{{ userProfile }} {{ currentUser }}</pre> -->
        
    </section>
</template>

<script>
    import { mapState } from 'vuex'
    import { territorial } from "../services/territorial.service";

    export default {
        data() {
            return {
                name: '',
                userName: '',
                description: '',
                contact: '',
                contactEmail: '',
                city: '',
                territorial: '',
                phone: '',
                web: '',
                whatsapp: '',
                instagram: '',
                twitter: '',
                facebook: '',
                showSuccess: false,
                territorials: territorial,
                mountedComponent: false
            }
        },
        computed: {
            ...mapState(['userProfile', 'currentUser', 'userBoxes'])
        },
        watch : {
            userProfile(val) {
                if (!this.mountedComponent) {
                    this.mountedComponent = true
                    this.mount()
                }
            }
        },
        mounted() {
            this.name = this.userProfile.name
            this.userName = this.userProfile.userName
            this.city = this.userProfile.city
            this.territorial = this.userProfile.territorial
            this.description = this.userProfile.description ? this.userProfile.description : ''
            this.contact = this.userProfile.contact ? this.userProfile.contact : ''            
            this.contactEmail = this.userProfile.contactEmail ? this.userProfile.contactEmail : ''
            this.phone = this.userProfile.phone
            this.web = this.userProfile.web

        },        
        methods: {
            mount() {
                this.name = this.userProfile.name
                this.userName = this.userProfile.userName
                this.city = this.userProfile.city
                this.territorial = this.userProfile.territorial
                this.description = this.userProfile.description ? this.userProfile.description : ''
                this.contact = this.userProfile.contact ? this.userProfile.contact : ''            
                this.contactEmail = this.userProfile.contactEmail ? this.userProfile.contactEmail : ''            
                this.phone = this.userProfile.phone
                this.web = this.userProfile.web
            },
            updateProfile() {
                this.$store.dispatch('updateProfile', {
                    name: this.name,
                    userName: this.userName,
                    email: this.currentUser.email,
                    description: this.description,
                    contact: this.contact,
                    phone: this.phone,
                    web: this.web,
                    city: this.city,
                    territorial: this.territorial,
                    contactEmail: this.contactEmail
                })

                this.showSuccess = true


                let msg = ''
                if (this.userBoxes.length == 0) {
                    msg = 'Continua afegint les dades de la teva iniciativa'
                }

                // setTimeout(() => { this.showSuccess = false }, 2000)
                this.$swal('Dades guardades', msg, 'success').then(() => {
                    if (this.userBoxes.length == 0) {
                        this.$router.push('/edita')
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Settings.vue